import { FormattedMessage } from "react-intl";
import { Form, useSubmit, useSearchParams } from "react-router-dom";
import { useRedirectLoaderData } from "./redirectApi.ts";
import styles from "./RedirectMain.module.scss";
import { useEffect, useRef } from "react";

export default function RedirectMain() {
  const { type } = useRedirectLoaderData();
  const [searchParams] = useSearchParams();
  // Loader error handler should catch URL problems
  const url = searchParams.get("url")!;
  const submit = useSubmit();
  const formRef = useRef<HTMLFormElement>(null);

  useEffect(() => {
    if (type === "safe") {
      const timeoutId = window.setTimeout(() => {
        submit(formRef.current);
      }, 2000);

      return () => clearTimeout(timeoutId);
    }
  }, [type, submit]);

  return (
    <Form className={styles.container} method="POST" ref={formRef}>
      <h1>
        <FormattedMessage
          defaultMessage="You're about to be redirected to <span>{url}</span>"
          values={{
            url,
            span: (chunks) => <span className={styles.url}>{chunks}</span>,
          }}
        />
      </h1>
      {type !== "blocked" && <input type="hidden" name="url" value={url} />}
      {type === "consent-required" && (
        <>
          <div>
            <FormattedMessage defaultMessage="We could not verify the identity of this site. Are you sure you want to continue?" />
          </div>
          {/* The fraction version of this also has a 'Go Back' button,
              but we currently only ever navigate in new tabs, where it
              doesn't make sense to have that */}
          <button className="vst-button-rectangle" type="submit">
            <FormattedMessage defaultMessage="Continue to Site" />
          </button>
        </>
      )}
      {type === "blocked" && (
        <div>
          <FormattedMessage defaultMessage="We could not verify the identity of this site. Navigation has been blocked." />
        </div>
      )}
    </Form>
  );
}
